export const HEADER_HEIGHT = 100;
export const HEADER_HEIGHT_MOBILE = 64;
export const HEADER_HEIGHT_EXTRA_TEXT = 22;
export const CHAIN_RESTAURANTS_ROW_HEIGHT = 262;

export const NEW_DESIGN_RES_LIST_TITLE_SIZES = {
  default: 82,
  largeMobile: 84,
  largeTablet: 84,
};

export const RESTAURANTS_ROW_HEIGHT = [293, 243, 271, 262];
export const RESTAURANTS_ROW_SPACING = [20, 24, 24, 24];
// Describes row height and spacing by number of columns [1 col, 2 col (tablet), 2 col (largeTablet) 3 col]
export const RESTAURANTS_ROW_HEIGHT_DENSE = [303, 244, 262, 262];
export const RESTAURANTS_ROW_SPACING_DENSE = [16, 20, 20, 21];
